// extracted by mini-css-extract-plugin
export default {"OptionsWrapper":"SignInModal_OptionsWrapper__5QvVY"};